import { makeStyles } from '@material-ui/core';

export const usePreFormRClubes = makeStyles(() => ({
  title: {
    fontSize: 16,
    marginBottom: 16,
    color: '#464646',
    textAlign: (props) => (props.mobile ? 'center' : null),
  },
  button: {
    marginTop: 16,
  },
}));
